exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.nav-link[data-v-1c03810a]{border-left:0;border-top:0;border-bottom:0}.site-design-section[data-v-1c03810a]{padding:2rem;display:flex;overflow:hidden;height:100%}.site-design-section .left[data-v-1c03810a]{flex:0 0 75%;display:flex;flex-direction:column}.site-design-section .right[data-v-1c03810a]{flex:0 0 25%;padding:0 2rem}", ""]);

// exports
